import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  Input,
  Typography,
} from "@mui/joy";
import {
  Edit as EditIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import { updateUserProfile } from "../../redux/authReducer";

const ProfileTab = ({ user }) => {
  const dispatch = useDispatch();
  const { isSaving } = useSelector((state) => state.auth);

  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
  });

  useEffect(() => {
    if (editMode && user) {
      setFormData({
        first_name: user?.first_name || "",
        last_name: user?.last_name || "",
        username: user?.username || "",
        email: user?.email || "",
      });
    }
  }, [editMode, user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const resultAction = await dispatch(
        updateUserProfile({ userId: user.id, formData })
      );
      if (updateUserProfile.fulfilled.match(resultAction)) {
        toast.success("Profile updated successfully!");
        setEditMode(false);
      } else if (updateUserProfile.rejected.match(resultAction)) {
        setErrors(resultAction.payload);
        toast.error("Failed to update profile. Please try again.");
      }
    } catch (error) {
      console.error("Failed to update user info", error);
      toast.error("Failed to update profile. Please try again.");
    }
  };

  const renderPersonalInformation = () => {
    if (editMode) {
      return (
        <>
          {Object.entries(formData).map(([key, value]) => (
            <Grid xs={12} sm={6} key={key}>
              <FormControl error={errors && !!errors[key]}>
                <FormLabel>{key.replace("_", " ").toUpperCase()}</FormLabel>
                <Input name={key} value={value} onChange={handleChange} />
                {errors && errors[key] && (
                  <Typography color="danger" fontSize="sm">
                    {errors[key]}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          ))}
          <Grid xs={12}>
            <Button onClick={handleSave} color="primary" disabled={isSaving}>
              {isSaving ? "Saving..." : "Save"}
            </Button>
          </Grid>
        </>
      );
    }

    return (
      <>
        <Grid xs={12} sm={6}>
          <Typography>
            <b>First Name:</b> {user.first_name || "N/A"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <Typography>
            <b>Last Name:</b> {user.last_name || "N/A"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <Typography>
            <b>Username:</b> {user.username || "N/A"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <Typography>
            <b>Email:</b> {user.email || "N/A"}
          </Typography>
        </Grid>
      </>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography level="title-md" fontWeight="bold">
          Personal Information
        </Typography>
        <IconButton onClick={() => setEditMode((prev) => !prev)}>
          {editMode ? <CloseIcon /> : <EditIcon />}
        </IconButton>
      </Box>
      <Grid container spacing={2}>
        {renderPersonalInformation()}
      </Grid>
      <Divider sx={{ my: 3 }} />
    </>
  );
};

export default ProfileTab;
